import { InputWithLabelProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: InputWithLabelProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as InputWithLabelProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
